import useMapStore from "@/store/mapStore";
import { useCallback } from "react";

export const useFetchActiveAds = () => {
  const DBAds = useMapStore((state) => state.DBAds);
  const setAds = useMapStore((state) => state.setAds);

  const fetchActiveAds = useCallback(() => {
    const now = Date.now();
    const activeAds = DBAds.filter((item) => {
      if (!item.isActive) return false;
      const afterStart = item.startDate == null || item.startDate <= now;
      const beforeEnd = item.endDate == null || now <= item.endDate;
      return afterStart && beforeEnd;
    });
    setAds(activeAds);
  }, [setAds, DBAds]);

  return { DBAds, fetchActiveAds };
};
